module.exports = __webpack_public_path__ + "img/bg.8e653be1.png";